export const mapEventTime = (time: number, dt: Date) => {
	const year = dt.getFullYear();
	const month = dt.getMonth();
	const date = dt.getDate();
	return new Date(year, month, date, time / 100, time % 100, 0);
};
